const FENCE_REGEX = /^\s{0,3}(`{3,}|~{3,})/;
const ATX_H2_REGEX = /^\s{0,3}##\s+(.+?)\s*#*\s*$/;

const ESCAPED_CHAR_REGEX = /\\([\\`*_{}[\]()#+\-.!>~|])/g;
const PLACEHOLDER_REGEX = /\u0000(\d+)\u0000/g;

const stripInlineMarkdown = (text: string): string => {
  const escaped: string[] = [];

  return text
    .replace(ESCAPED_CHAR_REGEX, (_match, char: string) => {
      escaped.push(char);
      return `\u0000${escaped.length - 1}\u0000`;
    })
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/(\*\*\*|___)(.+?)\1/g, "$2")
    .replace(/(\*\*|__)(.+?)\1/g, "$2")
    .replace(/(\*|_)(.+?)\1/g, "$2")
    .replace(PLACEHOLDER_REGEX, (_match, index: string) => escaped[Number(index)] ?? "")
    .trim();
};

export type MarkdownHeading = {
  label: string;
  line: number;
};

export const parseMarkdownHeadings = (markdown: string): MarkdownHeading[] => {
  const headings: MarkdownHeading[] = [];
  let openFence: string | null = null;
  let lineNumber = 0;

  for (const line of markdown.split("\n")) {
    lineNumber += 1;
    const fenceMatch = FENCE_REGEX.exec(line);

    if (openFence) {
      if (fenceMatch && line.trimStart().startsWith(openFence)) {
        openFence = null;
      }
      continue;
    }

    if (fenceMatch) {
      openFence = fenceMatch[1] ?? null;
      continue;
    }

    const headingMatch = ATX_H2_REGEX.exec(line);

    if (!headingMatch) {
      continue;
    }

    const label = stripInlineMarkdown(headingMatch[1] ?? "");

    if (label) {
      headings.push({ label, line: lineNumber });
    }
  }

  return headings;
};
